import React from 'react';
export default /*#__PURE__*/React.createContext({
  activeCell: {
    rowIndex: 0,
    columnIndex: 0
  },
  activeElement: null,
  mode: null,
  tableHasFocus: false,
  changeActiveCell: function changeActiveCell() {},
  changeActiveElement: function changeActiveElement() {},
  handleKeyDown: function handleKeyDown() {},
  registerInteractiveElement: function registerInteractiveElement() {},
  allowKeyboardNavigation: true,
  setAllowKeyboardNavigation: function setAllowKeyboardNavigation() {}
});
//# sourceMappingURL=table-context.js.map